import React, {useEffect, useState} from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  FlatList,
  Share,
} from 'react-native';
import {globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import CommonModal from '../../../commonComponents/commonModal';
import BackgroundHeaderCard from '../childComponents/backgroundHeaderCard';
import ClubEventDetail from '../childComponents/clubEventDetail';
import ClubImageCard from '../childComponents/clubImageCard';
import ClubMarketCard from '../childComponents/clubMarketCard';
import ClubMarketOptions from '../childComponents/clubMarketOptions';
import ClubOptionsBottomComponent from '../childComponents/ClubOptionsBottomComponent';
import {getClubEventDetails} from '../redux/clubs.action';
import {setLoaderVisibility} from '../../../utils/commonredux/commonRedux.action';
import {connect, useDispatch, useSelector} from 'react-redux';
import InvestedBlock from '../../event/childComponents/InvestedBlock';
import {usePolling} from '../../../common/usePolling';
import {getUser} from '../../Profile/redux/profile.action';
import EventDetailsBox from '../../event/childComponents/EventDetailsBox';
import CustomButton from '../../../commonComponents/CustomButton';
import {
  hideLoader,
  showLoader,
} from '../../../commonComponents/Loader/loader.actions';
import {globalConfigurableData, globalConst} from "../../../utils/globalConstant";

const ClubMarketDetail = ({
  navigation,
  getClubEventDetails,
  clubEventDetails,
  setLoaderVisibility,
  getUser,
  route,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const isAppLogin = useSelector(({utilReducer}) => utilReducer.isAppLogin);
  const isOwner = clubEventDetails?.is_owner;
  const {clubId, eventId} = route.params;
  const dispatch = useDispatch();

  const onBottomSheetClose = () => {
    if (!selectedOption?.clubOrderResponse?.isSettlement) {
      if (selectedOption?.clubOrderResponse) {
        getClubEventDetails({eventId, clubId});
      }
      setSelectedOption(null);
    }
  };

  useEffect(() => {
    getSelectedClubDetails();
    if (isAppLogin) {
      getUser();
    }
  }, []);

  const getSelectedClubDetails = async () => {
    setLoaderVisibility(true);
    await getClubEventDetails({eventId, clubId});
    setLoaderVisibility(false);
  };
  const backButtonHandle = () => {
    navigation.pop();
  };

  const onOptionClick = (optionSelected, optionIndex) => {
    if (!isOwner) {
      const a = {
        optionsData: optionSelected,
        optionIndex,
        isShow: true,
        clubOrderResponse: null,
      };
      setSelectedOption(a);
    } else {
      onSettleEvent(optionSelected, optionIndex);
    }
  };

  usePolling(
    () => {
      if (!selectedOption?.isShow) {
        getClubEventDetails({eventId, clubId});
      }
    },
    5000,
    true,
  );

  const onShareClick = async () => {
    dispatch(showLoader());
    var msg =
      'Inviting you to share opinion on an event : ' +
      clubEventDetails?.title +
      ' .Click on the link below to join the club on ' +
      globalConfigurableData?.appName +
      '. \nInvitation Link: ' +
      clubEventDetails?.shareable_url;
    Share.share({
      message: msg,
    }).then(() => {
      dispatch(hideLoader());
    });
  };

  useEffect(() => {
    if ((clubEventDetails && !clubEventDetails?.is_member) || !isAppLogin) {
      navigation.pop();
      navigation.navigate('ClubStack', {
        screen: 'ClubMarkets',
        params: {club_id: clubId},
      });
    }
  }, [clubEventDetails?.is_member]);

  const onSettleEvent = (optionSelected, optionIndex) => {
    if (optionIndex === null || optionIndex === undefined) {
      optionIndex = 0;
      clubEventDetails.options.map((item, index) => {
        if (clubEventDetails?.options[optionIndex].roi > item?.roi) {
          optionIndex = index;
        }
      });
      optionSelected = clubEventDetails?.options[optionIndex];
    }

    const popupData = {
      optionsData: optionSelected,
      optionIndex,
      isShow: true,
      isShowSettle: true,
      clubOrderResponse: null,
      isSettleConfirmation: false,
    };
    setSelectedOption(popupData);
  };

  const settleOrderHandler = isError => {
    setSelectedOption(null);
    if (!isError) {
      navigation.pop();
    }
  };

  const orderStatusHandler = (args = {}) => {
    const {orderResponse, isSettleConfirmation, isEdit} = args;
    if (isEdit) {
      setSelectedOption({
        ...selectedOption,
        isSettleConfirmation: false,
      });
      return;
    }
    if (isSettleConfirmation) {
      setSelectedOption({
        ...selectedOption,
        isSettleConfirmation: true,
      });
      return;
    }
    if (!orderResponse) {
      onBottomSheetClose();
    } else {
      setSelectedOption({
        ...selectedOption,
        clubOrderResponse: orderResponse,
      });
    }
  };

  const redirectionClick = () => {
    navigation.navigate({
      name: 'ClubMarkets',
      params: {club_id: clubId, tab: 'Live'},
      merge: true,
    });
  };
  return (
    <View style={{backgroundColor: Colors.bgWhite, flex: 1}}>
      <BackgroundHeaderCard
        pageTitle={''}
        backButtonHandle={backButtonHandle}
        customStyle="mob-profile-header"
        customStyleTitle="app-font-heading app-white"
        onShareClick={onShareClick}
        link={clubEventDetails?.shareable_url}
        title={clubEventDetails?.title}
      />
      <View
        style={{
          paddingHorizontal: 12,
          paddingTop: 40,
          backgroundColor: Colors.grey5,
        }}>
        <ClubImageCard
          title={clubEventDetails?.title}
          titleImg={clubEventDetails?.image_url}
        />
        <ClubMarketOptions
          onOptionClick={onOptionClick}
          clubmarketOptions={clubEventDetails?.options || []}
          isOwner={isOwner}
        />

        {clubEventDetails?.invested_amount && (
          <InvestedBlock
            investedAmount={clubEventDetails?.invested_amount}
            customBlkClass={'club-invested-blk'}
            redirectionText={'Check Live'}
            redirectionClick={redirectionClick}
          />
        )}
      </View>

      <View style={{paddingHorizontal: 12, marginTop: 27}}>
        <ClubEventDetail clubEventDetails={clubEventDetails} />
        <EventDetailsBox
          text={'Market will be settled as per rules mentioned here.'}
          title={'Market Resolution'}
          eventInfo={{resolution: clubEventDetails?.rules}}
          isNews={false}
        />
      </View>
      {isOwner && (
        <View style={globalStyle.bottomAbsBtnBar}>
          <CustomButton
            btnText={'Settle Event'}
            btnType="normalBlue"
            onBtnClick={onSettleEvent}
          />
        </View>
      )}

      <CommonModal
        onModalCallBack={onBottomSheetClose}
        customModalStyle={[globalStyle.modalView]}
        showModal={selectedOption?.isShow || false}>
        <ClubOptionsBottomComponent
          selectedOption={selectedOption}
          onOptionClick={onOptionClick}
          orderStatusHandler={orderStatusHandler}
          onBottomSheetClose={onBottomSheetClose}
          settleOrderHandler={settleOrderHandler}
          clubEventDetails={clubEventDetails}
          isOwner={isOwner}
        />
      </CommonModal>
    </View>
  );
};

const mapStateToProps = ({socialClubReducer}) => ({
  clubEventDetails: socialClubReducer?.clubEventDetails,
});

const mapDispatchToProps = {
  setLoaderVisibility,
  getClubEventDetails,
  getUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClubMarketDetail);
